import {Tooltip, Typography} from "antd";
import React from "react";
const { Text } = Typography;

export const renderCommitID = (commitID: string|null|undefined) => commitID?<Tooltip title={"Commit ID: "+commitID}><Text>{commitID.slice(0, 8)}</Text></Tooltip>:"-"
